import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import TextInput from 'components/TextInput';
import RadioGroup from 'components/RadioGroup';
import DatePicker from 'components/DatePicker';
import Tr from 'translations/Translations';
import GridBlock from 'components/GridBlock';
import booleanValues from 'constants/BooleanItems'
import InputLimits from 'constants/InputLimits';
import getObjectValue from 'libs/getObjectValue'

const limits = InputLimits.procedure.basicInformation;

const style = theme => ({
	root: {

	}
})

function OptionalFields({
	formikProps,
	classes,
}) {
	const euFunded = getObjectValue('euFunded', formikProps.values, false)
	return (
		<GridBlock
			column
		>
			<TextInput
				id='externalPurchaseRequestNumber'
				label={Tr('application_number') + ' (EOD)'}
				formikProps={formikProps}
				limit={limits.EOD}
			/>
			<RadioGroup
				id='euFunded'
				label={Tr('eu_funds_question')}
				formikProps={formikProps}
				items={booleanValues}
			/>
			{euFunded === "true" &&
				<TextInput
					id='euProjectNumber'
					label={Tr('eu_project_number')}
					formikProps={formikProps}
					limit={limits.EU_PROJECT_NUMBER}
					multiline
				/>}
			<TextInput
				id='singleDealingJustification'
				label={Tr('justification_parts')}
				formikProps={formikProps}
				limit={limits.SINGLE_DEALING_JUSTIFICATION}
				multiline
			/>
			<TextInput
				id='demandJustification'
				label={Tr('justification_order')}
				formikProps={formikProps}
				multiline
			/>
			<TextInput
				id='planPropositionText'
				label={Tr('position_procurement_plan')}
				formikProps={formikProps}
				multiline
			/>
			<TextInput
				id='estimationBase'
				label={Tr('contract_calculating_basis')}
				formikProps={formikProps}
				limit={limits.ESTIMATION_BASE}
				multiline
			/>
			<TextInput
				id='financialSource'
				label={Tr('financing_source')}
				formikProps={formikProps}
				limit={limits.FINANCIAL_SOURCE}
				multiline
			/>
			<RadioGroup
				id='termOption'
				label={Tr('term_deadline')}
				formikProps={formikProps}
				items={[
					{ label: Tr('date'), value: "date" },
					{ label: Tr('description'), value: "text" },
				]}
			/>
			{formikProps.values.termOption === 'date' ?
				<DatePicker
					id='termDate'
					label={Tr('choose_date')}
					formikProps={formikProps}
				/>
				:
				<TextInput
					id='termDescription'
					label={Tr('description')}
					formikProps={formikProps}
					limit={limits.TERM_DESCRIPTION}
					multiline
				/>
			}
			<DatePicker
				id='orderValueDecisionDate'
				label={Tr('date_estimating_value')}
				formikProps={formikProps}
				maxDate={new Date()}
			/>

			<TextInput
				id='fullNameOrderValueDecisionPerson'
				label={Tr('fullname_estimating_person')}
				formikProps={formikProps}
				limit={limits.FULL_NAME}
				multiline
			/>
			<TextInput
				id='managerEntrustedPerson'
				label={Tr('manager_entrusted_person')}
				formikProps={formikProps}
				limit={limits.FULL_NAME}
			/>
		</GridBlock>
	)
}

OptionalFields.propTypes = {
	classes: PropTypes.any,
	formikProps: PropTypes.object,
}

OptionalFields.defaultProps = {
}

export default withStyles(style)(OptionalFields);